module.exports = __webpack_public_path__ + "img/none.70725bc6.png";